var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('IbClientTabs'),(_vm.$route.params.market=='crypto')?_c('CryptoTraderHistory'):_vm._e(),(_vm.$route.params.market=='forex')?_c('ForexTraderHistory'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }